import { ImageHover } from "./components/ImageHover";
import IconVideo from "./icon-video.svg?react";
import "./index.scss";
import UploadImage from "@components/UploadImage";
import { IconAd, IconImageEmpty, IconVideoEmpty } from "@icons/index";
import IconBreakBown from "./components/breakbown.svg?react";
import { Popover } from "antd";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import FullService from "./components/FullService";

interface ImageProps {
  type?: CoverType;
  className?: string;
  url?: string;
  defaultUrl?: string;
  rounded?: boolean;
  bordered?: boolean;
  children?: React.ReactElement;
  videoIcon?: boolean;
  videoIconSize?: "size48" | string;
  adIconSize?: string;
  playingIcon?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  style?: React.CSSProperties;
  hoverEnlarge?: boolean;
  showAdIcon?: boolean;
  videoId?: string;
  region?: string;
  id?: string;
  isFullService?: boolean; // 是否是全托管
  fullServiceClassName?: string;
  videoType?: VIDEO_TYPE;
  hoverClassName?: string;
  showBreakdownIcon?: boolean;
  emptyClassName?: string;
}

export default ({
  type = "image",
  className,
  url,
  rounded = false,
  bordered = false,
  videoIcon = false,
  videoIconSize,
  adIconSize,
  playingIcon = false,

  children,
  onClick,
  style = {},
  hoverEnlarge = false,
  showAdIcon,
  isFullService,
  fullServiceClassName,
  videoType,
  hoverClassName,
  showBreakdownIcon = false,
  emptyClassName,
}: ImageProps) => {
  const [backgroundImage, setBackgroundImage] = useState<string>("");
  const [imageError, setImageError] = useState<boolean>(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!url) {
      setBackgroundImage("");
      setImageError(false);
      return;
    }

    // 预加载图片，检测加载是否成功
    const img = new Image();
    img.onload = () => {
      setBackgroundImage(url);
      setImageError(false);
    };
    img.onerror = () => {
      setBackgroundImage("");
      setImageError(true);
    };
    img.src = url;
  }, [url]);
  const uiImage = (
    <div
      ref={wrapRef}
      className={classNames(
        "Component-Image ",
        rounded ? "round" : "",
        className,
        bordered ? "bordered" : "",
        className,
      )}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        ...style,
      }}
      onClick={(event) => onClick && onClick(event)}
    >
      {(!url || imageError) && (
        <div className={classNames("bg-kds-bg-subtle w-full h-full flex items-center justify-center", className)}>
          {type === "video" && (
            <IconVideoEmpty className={classNames("w-1/2 max-w-[110px] min-w-[24px] aspect-square", emptyClassName)} />
          )}
          {type === "image" && (
            <IconImageEmpty className={classNames("w-1/2 max-w-[110px] min-w-[24px] aspect-square", emptyClassName)} />
          )}
        </div>
      )}

      {!showBreakdownIcon && videoIcon && !playingIcon && (
        <IconVideo className={classNames("icon-video absolute", videoIconSize)}></IconVideo>
      )}

      {url && !imageError && showAdIcon && !showBreakdownIcon && (
        <IconAd className={classNames("icon-ad absolute left-0 top-0 ", adIconSize)}></IconAd>
      )}
      {url && !imageError && showBreakdownIcon && (
        <IconBreakBown className={classNames("icon-ad absolute right-0 top-0 ", adIconSize)}></IconBreakBown>
      )}

      <FullService isFullService={isFullService} className={fullServiceClassName}></FullService>
      {videoType === "multi_photo" && (
        <UploadImage
          name="5c14f562.png"
          className={twMerge(
            "absolute top-0 right-0 ",
            videoIconSize === "size48" ? "w-[24px] h-[24px]" : "w-[16px] h-[16px]",
          )}
        ></UploadImage>
      )}
      {children}
    </div>
  );
  if (url && !imageError && hoverEnlarge) {
    return (
      <Popover
        overlayClassName="image-hover"
        placement="topRight"
        content={() => {
          return (
            <ImageHover
              refImage={wrapRef}
              rounded={rounded}
              backgroundImage={backgroundImage}
              isFullService={isFullService}
              className={hoverClassName}
            ></ImageHover>
          );
        }}
        arrow={false}
        destroyOnHidden={true}
      >
        {uiImage}
      </Popover>
    );
  }
  return uiImage;
};
